import { render, staticRenderFns } from "./ProductData.vue?vue&type=template&id=41853825&scoped=true"
import script from "./ProductData.vue?vue&type=script&lang=js"
export * from "./ProductData.vue?vue&type=script&lang=js"
import style0 from "./ProductData.vue?vue&type=style&index=0&id=41853825&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41853825",
  null
  
)

export default component.exports